import React, { useState } from 'react';
import { Fade } from '@material-ui/core';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { compose } from 'redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import ButtonBase from '@material-ui/core/ButtonBase';
import { CopyIcon } from '../statelessComponents/Icons';

const messages = defineMessages({
  successTitle: {
    id: 'CopyToClipboard.successTitle',
    defaultMessage: 'Copied',
  },
  hintTitle: {
    id: 'CopyToClipboard.hintTitle',
    defaultMessage: 'Copy to clipboard',
  },
});

const CopyToClipboard = ({
  intl: { formatMessage },
  copyText,
  successTitle,
  hintTitle,
  className,
  children,
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyTextToClipboard = async text => {
    if ('clipboard' in navigator) {
      return navigator.clipboard.writeText(text);
    }
    return document?.execCommand('copy', true, text);
  };

  const handleCopyClick = () => {
    copyTextToClipboard(copyText)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch(err => {
        console.error(err);
      });
  };

  if (children) {
    return (
      <div className={classNames(className)}>
        <Tooltip
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 1000 }}
          title={successTitle || formatMessage(messages.successTitle)}
          open={isCopied}
        >
          <ButtonBase
            data-test-id="E2YRoS1jFtwmR_N6QFz23"
            onClick={handleCopyClick}
          >
            {children}
          </ButtonBase>
        </Tooltip>
      </div>
    );
  }

  return (
    <span className={classNames(className)}>
      <Tooltip
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 1000 }}
        title={successTitle || formatMessage(messages.successTitle)}
        open={isCopied}
      >
        <Tooltip
          title={isCopied ? '' : hintTitle || formatMessage(messages.hintTitle)}
        >
          <IconButton
            data-test-id="kSIwD1OqzRR72iDHNdIdO"
            onClick={handleCopyClick}
          >
            <CopyIcon />
          </IconButton>
        </Tooltip>
      </Tooltip>
    </span>
  );
};

CopyToClipboard.propTypes = {
  intl: intlShape.isRequired,
  copyText: PropTypes.string.isRequired,
  successTitle: PropTypes.string,
  hintTitle: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

CopyToClipboard.defaultProps = {
  successTitle: '',
  hintTitle: '',
  className: '',
  children: null,
};

export default compose(injectIntl)(CopyToClipboard);
